import "./ObjectSelectComp.css";
import { defineComponent as _, resolveComponent as p, openBlock as o, createElementBlock as s, createVNode as i, withCtx as a, Fragment as b, renderList as f, createBlock as S, normalizeClass as l, createElementVNode as c, renderSlot as j, toDisplayString as v } from "vue";
import { SelectGroupComp as g } from "./SelectGroupComp.js";
import { SelectGroupOptionComp as V } from "./SelectGroupOptionComp.js";
import { _ as y } from "./_plugin-vue_export-helper.dad06003.js";
const C = _({
  events: {
    "update:modelValue": {
      type: Object
    }
  },
  components: {
    SelectGroupComp: g,
    SelectGroupOptionComp: V
  },
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    options: {
      type: Array,
      required: !0
    }
  },
  computed: {
    selectedOption: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
});
const O = { class: "objectSelect" };
function $(e, r, h, k, B, x) {
  const u = p("select-group-option-comp"), m = p("select-group-comp");
  return o(), s("div", O, [
    i(m, {
      modelValue: e.selectedOption,
      "onUpdate:modelValue": r[0] || (r[0] = (t) => e.selectedOption = t)
    }, {
      default: a(() => [
        (o(!0), s(b, null, f(e.options, (t, d) => (o(), S(u, {
          key: t.text,
          value: t,
          class: l({
            objectSelect__container: !0,
            "objectSelect--borderBottom": d !== e.options.length - 1
          })
        }, {
          default: a(({ isSelected: n }) => [
            c("div", {
              class: l({
                objectSelect__option: !0,
                "objectSelect__option--selected": n
              })
            }, [
              c("div", {
                class: l({
                  objectSelect__circle: !0,
                  "objectSelect__circle--selected": n
                })
              }, null, 2),
              j(e.$slots, "label", { option: t }, () => [
                c("p", null, v(t.text), 1)
              ], !0)
            ], 2)
          ]),
          _: 2
        }, 1032, ["value", "class"]))), 128))
      ]),
      _: 3
    }, 8, ["modelValue"])
  ]);
}
const z = /* @__PURE__ */ y(C, [["render", $], ["__scopeId", "data-v-28c7e93a"]]);
export {
  z as ObjectSelectComp
};
//# sourceMappingURL=ObjectSelectComp.js.map
